export default "__VITE_PUBLIC_ASSET__a445bea6__"